export const LOGOUT_URL = 'log-out';
export const CONTACT_SUPPORT_URL = 'contact-support';
export const COOKIE_SETTINGS_URL = 'cookie-settings';
export const NAVIGATION_LOCALIZATION_SCOPE = 'navigation';
